<template>
  <div class="basic-information">
    <bp-input
      v-model="form.name"
      required
      class="mb-6"
      label="Nome do produto"
      placeholder="Prefira um nome que chame a atenção do público"
      description="Atenção! Este é o nome que exibiremos para os seus compradores."
      :limit="64"
    />

    <bp-input
      v-model="form.description"
      :rows="4"
      textarea
      required
      class="mb-6"
      label="Descrição (SEO)"
      placeholder="Explique de forma breve do que se trata o seu produto"
      description="Essa descrição nos ajudará na análise do seu produto."
      :limit="980"
    />

    <action-dispatcher action="product/getCategories">
      <bp-select
        v-model="form.category_id"
        required
        label="Categoria do produto"
        placeholder="Selecionar uma categoria"
        description="Escolha a categoria adequada apara que seus compradores encontrem seu produto mais facilmente."
        :options="categories"
      />
    </action-dispatcher>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    form: {
      type: Object,
      default: null
    },
    product: {
      type: Object,
      default: null
    },
    errors: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapState("product", ["categories"])
  },
  watch: {
    form(val) {
      if (val.category) {
        this.form.category_id = val.category.id;
      }
    }
  }
};
</script>
